import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { id: "products", label: "Products", testid: "nav-link-products" },
    { id: "cookbook", label: "Cookbook", testid: "nav-link-cookbook" },
    { id: "story", label: "Our Story", testid: "nav-link-story" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-coal/80 backdrop-blur-xl"
            data-testid="navbar"
        >
            <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
                <button
                    onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="flex items-center gap-3"
                    data-testid="nav-brand-logo"
                >
                    <LogoMark className="h-9 w-9 transition-transform duration-300 hover:rotate-6" />
                    <span className="font-display text-lg font-extrabold uppercase tracking-tight text-parchment">
                        SpiceJam <span className="text-nutmeg">Kitchen</span>
                    </span>
                </button>

                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            onClick={() => go(l.id)}
                            className="text-sm font-semibold uppercase tracking-[0.18em] text-sand transition-colors duration-300 hover:text-nutmeg"
                            data-testid={l.testid}
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        onClick={() => go("launch-list")}
                        className="rounded-full bg-nutmeg px-5 py-2.5 text-sm font-bold uppercase tracking-[0.12em] text-obsidian transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-nutmegwarm"
                        data-testid="nav-link-launch-list"
                    >
                        Join the launch list
                    </button>
                </nav>

                <button
                    className="text-parchment md:hidden"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
            </div>

            {open && (
                <div className="border-t border-white/10 bg-coal/95 px-5 py-6 backdrop-blur-xl md:hidden" data-testid="nav-mobile-menu">
                    <div className="flex flex-col gap-5">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                onClick={() => go(l.id)}
                                className="text-left text-sm font-semibold uppercase tracking-[0.18em] text-sand"
                                data-testid={`${l.testid}-mobile`}
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            onClick={() => go("launch-list")}
                            className="w-fit rounded-full bg-nutmeg px-5 py-2.5 text-sm font-bold uppercase tracking-[0.12em] text-obsidian"
                            data-testid="nav-link-launch-list-mobile"
                        >
                            Join the launch list
                        </button>
                    </div>
                </div>
            )}
        </motion.header>
    );
};

export default Navbar;
